import React, { useEffect, useState } from 'react';
import { Table, Button, Modal, InputNumber, Spin, Card, Tag, Statistic, Row, Col, Input,Popconfirm } from 'antd';
import { PlusOutlined, ArrowUpOutlined, ShoppingCartOutlined, StockOutlined, SearchOutlined,DeleteOutlined } from '@ant-design/icons';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Api from '../api/Api';
import formatarValor from '../formatarValor';
import { useTurnoModal } from "../useTurnoModal";


const { Search } = Input;

const Inventario = () => {
  const [produtos, setProdutos] = useState([]);
  const [produtosFiltrados, setProdutosFiltrados] = useState([]);
  const [fila, setFila] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedProduto, setSelectedProduto] = useState(null);
  const [qtd, setQtd] = useState(1);
  const [addLoading, setAddLoading] = useState(false);
  const [finalLoading, setFinalLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [qtdPorLinha, setQtdPorLinha] = useState({});
  const { abrirModal, modal } = useTurnoModal();
  


  useEffect(() => {
    document.title = 'Inventário';
    carregarProdutos();
  }, []);

  // Filtra produtos quando o searchTerm muda
  useEffect(() => {
    if (searchTerm) {
      const filtered = produtos.filter(produto =>
        produto.descricao.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setProdutosFiltrados(filtered);
    } else {
      setProdutosFiltrados(produtos);
    }
  }, [searchTerm, produtos]);

  const sms_error = (msg) => toast.error(msg);
  const sms_success = (msg) => toast.success(msg);

  const carregarProdutos = async () => {
    setLoading(true);
    try {
      const response = await Api.ListProduto();
      const dados = Array.isArray(response) ? response : [];

      const formatado = dados.map(item => ({
        key: item.id,
        id: item.id,
        descricao: item.descricao,
        custo: item.custo,
        precovenda: `${parseFloat(item.precovenda).toFixed(2)}`,
        qtd: Number( item.qtd).toFixed(0),
        status:  Number( item.qtd).toFixed(0)  < 10 ? 'baixo' :  Number( item.qtd).toFixed(0)  < 50 ? 'medio' : 'alto'
       // item.qtd < 10 ? 'baixo' : item.qtd < 50 ? 'medio' : 'alto'
      }));

      setProdutos(formatado);
      setProdutosFiltrados(formatado);
    } catch (e) {
      sms_error("Erro ao carregar produtos");
    }
    setLoading(false);
  };

  const carregarFila = async () => {
    try {
      const response = await Api.ListInventario();
      const dados = Array.isArray(response) ? response : [];

      const formatado = dados.map(item => ({
        key: item.id,
        id: item.id,
        custo: item.custo,
        total: item.total,
        produto: item.produto,
        precovenda: item.precovenda,
        qtd: item.qtd
      }));

      setFila(formatado);
    } catch (e) {
      sms_error("Erro ao carregar fila");
    }
  };

 const abrirModalEntrada = async () => {
  const id = localStorage.getItem("id_turno");

  if (!id) {
    abrirModal(() => {
      toast.success("Agora pode continuar a operação!");
      setModalVisible(true); // agora abre o modal!
    });
  } else {
  //  toast.info("Turno está aberto → operação liberada!");
    setModalVisible(true);
  }

  await carregarFila();
  setSearchTerm('');
  setSelectedProduto(null);
};



const adicionarNaFila = async (produto, quantidade) => {
  if (!produto) {
    sms_error("Produto inválido");
    return;
  }

if (quantidade == null || quantidade < 0) {
  sms_error("Informe uma quantidade válida");
  return;
}


  setAddLoading(true);

  try {
    const result = await Api.AddProcessoInventario({
      id_produto: produto.id,
      qtd: quantidade,
      id_turno: localStorage.getItem("id_turno")
    });

    if (result.success) {
      sms_success("Produto adicionado à fila!");
      await carregarFila();

      // limpa somente o campo da linha usada
      setQtdPorLinha(prev => ({ ...prev, [produto.id]: 1 }));
    } else {
      sms_error(result.message || "Erro ao adicionar");
    }
  } catch (error) {
    sms_error("Erro ao adicionar: " + error.message);
  }

  setAddLoading(false);
};






    const removerDaFila = async (id) => {
    try {
      const result = await Api.DeleteProcesso({ id });
      if (result.success) {
        sms_success('Produto removido da fila');
        carregarFila();
      } else {
        sms_error('Erro ao remover');
      }
    } catch {
      sms_error('Erro ao remover item');
    }
  };

  const finalizarEntrada = async () => {
    setFinalLoading(true);

    try {
      const result = await Api.AddInventario();

      if (result.success) {
        sms_success("Entrada finalizada!");
        setModalVisible(false);
        await carregarProdutos();
        setSelectedProduto(null); // Limpa seleção ao fechar modal
        setSearchTerm(''); // Limpa pesquisa
      } else {
        sms_error(result.message || "Erro ao finalizar entrada");
      }
    } catch (e) {
      sms_error("Erro ao finalizar entrada");
    }

    setFinalLoading(false);
  };

  const handleSearch = (value) => {
    setSearchTerm(value);
  };

  // Estatísticas
  const totalProdutos = produtos.length;
  const totalEmEstoque = produtos.reduce((sum, item) => sum + (item.qtd || 0), 0);
  const itensNaFila = fila.length;

  // Colunas
  const colunasProdutos = [
    { 
      title: "Descrição", 
      dataIndex: "descricao",
      render: (text) =>text 
    },
     { 
      title: "Custo", 
      dataIndex: "custo",
      render: (text) =>  formatarValor(text)
    },
    { 
      title: "Preço", 
      dataIndex: "precovenda",
      render: (text) =>  formatarValor(text)
    },
    { 
      title: "Qtd Atual", 
      dataIndex: "qtd",
      render: (qtd, record) => (
        <Tag 
          color={
            record.status === 'baixo' ? '#f50' : 
            record.status === 'medio' ? '#faad14' : '#87d068'
          }
        >
          {qtd} unidades
        </Tag>
      )
    },
  ];

  const colunasProdutosModal = [
  { 
    title: "Descrição", 
    dataIndex: "descricao"
  },
  { 
    title: "Custo", 
    dataIndex: "custo",
    render: (v) => formatarValor(v)
  },
  { 
    title: "Preço", 
    dataIndex: "precovenda",
    render: (v) => formatarValor(v)
  },
  { 
    title: "Qtd Atual", 
    dataIndex: "qtd",
    render: (qtd, record) => (
      <Tag 
        color={
          record.status === 'baixo' ? '#f50' : 
          record.status === 'medio' ? '#faad14' : '#87d068'
        }
      >
        {qtd} unidades
      </Tag>
    )
  },

 
  {
    title: "Ação",
    render: (_, record) => (
      <div style={{ display: "flex", gap: 8 }}>
        <InputNumber
          min={0}
          value={qtdPorLinha[record.id] || 0}
          onChange={(value) =>
            setQtdPorLinha(prev => ({ ...prev, [record.id]: value }))
          }
          style={{ width: 80 }}
        />

        <Button
          type="primary"
          icon={<PlusOutlined />}
          loading={addLoading}
          onClick={() =>
            adicionarNaFila(record, qtdPorLinha[record.id] || 0)
          }
        />
      </div>
    )
  }
];


  const colunasFila = [
    { title: 'Produto', dataIndex: 'produto', render: t => <strong>{t}</strong> },
    {
      title: 'Quantidade',
      dataIndex: 'qtd',
      render: qtd => <Tag color="blue">+{qtd}</Tag>
    },
    { title: 'Custo', dataIndex: 'custo', render: t => formatarValor(t) },
    { title: 'Total', dataIndex: 'total', render: t => formatarValor(t) },
    {
      title: 'Ações',
      render: (_, record) => (
        <Popconfirm
          title="Eliminar item da fila?"
          okText="Sim"
          cancelText="Não"
          onConfirm={() => removerDaFila(record.id)}
        >
          <Button danger icon={<DeleteOutlined />} />
        </Popconfirm>
      )
    }
  ];

  return (
    <div style={{ padding: '24px', backgroundColor: '#f5f5f5', minHeight: '100vh' }}>
      <ToastContainer />

       

      {/* Card Principal */}
      <Card 
        title={
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <span>
              <StockOutlined style={{ marginRight: '8px', color: '#1890ff' }} />
              Inventário
            </span>
            <Button 
              type="primary"
              icon={<PlusOutlined />}
              onClick={abrirModalEntrada}
              size="large"
              style={{
                background: 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)',
                border: 'none',
                borderRadius: '6px',
                fontWeight: 'bold'
              }}
            >
              Nova Entrada
            </Button>
          </div>
        }
        style={{
          borderRadius: '12px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
          border: 'none'
        }}
      >
        <Spin spinning={loading}>
          <Table
            columns={colunasProdutos}
            dataSource={produtos}
            pagination={{ 
              pageSize: 13,
              showSizeChanger: true,
              showQuickJumper: true,
              showTotal: (total, range) => 
                `${range[0]}-${range[1]} de ${total} itens`
            }}
            style={{
              borderRadius: '8px',
              overflow: 'hidden'
            }}
          />
        </Spin>
      </Card>

      {/* MODAL ENTRADA */}
      <Modal
        open={modalVisible}
        title={
          
          <div style={{ textAlign: 'center', fontSize: '20px', fontWeight: 'bold' }}>
            
            Inventário
          </div>
        }
        onCancel={() => {
          setModalVisible(false);
          setSelectedProduto(null);
          setSearchTerm('');
        }}
        footer={null}
        width={1600}
        style={{ borderRadius: '12px' }}
        bodyStyle={{ padding: '20px' }}
      >
        <div style={{ display: 'flex', gap: '24px', minHeight: '500px' }}>
          
          {/* Lado esquerdo - Produtos */}
          <Card 
            title="Lista de Produtos"
            style={{ flex: 1, borderRadius: '8px' }}
            headStyle={{ 
              backgroundColor: '#fafafa',
              borderBottom: '2px solid #1890ff',
              fontSize: '16px',
              fontWeight: 'bold'
            }}
            extra={
              <Search
                placeholder="Pesquisar produto..."
                allowClear
                enterButton={<SearchOutlined />}
                size="middle"
                onSearch={handleSearch}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{ width: 250 }}
                value={searchTerm}
              />
            }
          >
       <Table
  columns={colunasProdutosModal}
  dataSource={produtosFiltrados}
  size="middle"
  pagination={{ pageSize: 6 }}
  locale={{
    emptyText: searchTerm ? 'Nenhum produto encontrado' : 'Nenhum produto disponível'
  }}
/>


            {selectedProduto && (
              <Card 
                title="Adicionar Quantidade" 
                size="small"
                style={{ 
                  backgroundColor: '#f6ffed',
                  border: '1px solid #b7eb8f',
                  transition: 'all 0.3s ease'
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <div style={{ flex: 1 }}>
                    <strong>Produto:</strong> {selectedProduto.descricao}
                    <br />
                    <small style={{ color: '#666' }}>
                      Estoque atual: {selectedProduto.qtd} unidades
                    </small>
                  </div>
                  <InputNumber
                    min={1}
                    value={qtd}
                    onChange={setQtd}
                    style={{ width: '100px' }}
                    size="large"
                    placeholder="Qtd"
                  />
                  <Button 
                    type="primary"
                    loading={addLoading}
                    onClick={adicionarNaFila}
                    size="large"
                    style={{
                      background: 'linear-gradient(135deg, #52c41a 0%, #389e0d 100%)',
                      border: 'none',
                      borderRadius: '6px'
                    }}
                  >
                    Adicionar à Fila
                  </Button>
                </div>
              </Card>
            )}
          </Card>

          {/* Lado direito - Fila */}
          <Card 
            title={`Fila de Entrada (${fila.length})`}
            style={{ flex: 1, borderRadius: '8px' }}
            headStyle={{ 
              backgroundColor: '#fafafa',
              borderBottom: '2px solid #1890ff',
              fontSize: '16px',
              fontWeight: 'bold'
            }}
          >
            <Table
              columns={colunasFila}
              dataSource={fila}
              size="middle"
              pagination={{ pageSize: 6 }}
              style={{ marginBottom: '16px' }}
              locale={{
                emptyText: 'Nenhum produto na fila'
              }}
            />

            <Button
              type="primary"
              loading={finalLoading}
              onClick={finalizarEntrada}
              size="large"
              block
              style={{
                height: '50px',
                fontSize: '16px',
                fontWeight: 'bold',
                background: 'linear-gradient(135deg, #1890ff 0%, #1890ff 100%)',
                border: 'none',
                borderRadius: '8px',
                marginTop: 'auto'
              }}
              disabled={fila.length === 0}
            >
              {fila.length === 0 ? 'Fila Vazia' : `Finalizar Entrada (${fila.length} itens)`}
            </Button>
          </Card>
        </div>
      </Modal>
          {modal}
    </div>
  );
};

export default Inventario;